import { render, staticRenderFns } from "./DepositHistory.vue?vue&type=template&id=50ef67a6&"
import script from "./DepositHistory.vue?vue&type=script&lang=js&"
export * from "./DepositHistory.vue?vue&type=script&lang=js&"
import style0 from "./DepositHistory.vue?vue&type=style&index=0&id=50ef67a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports